import actions from './actions';

const initState = { idToken: null, emailId : null, userId: null };

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return {
        idToken: action.token,
        emailId : action.email,
        userId: action.userid
      };
    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
